module.exports = new __parcel__URL__("alphawallet.b6df19bd.svg").toString();